/* --------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

import _ from 'lodash';
import defaultAppConfig from '../../config/default';

const CONFIG_LOAD_APP = 'CONFIG_LOAD_APP';

const state = {
  appConfig: defaultAppConfig,
};

const mutations = {
  [CONFIG_LOAD_APP] (state, config) {
    _.merge(state.appConfig, config);
  },
};

const actions = {
  loadAppConfig: ({ commit }) => {
    const runtimeConfig = window.VV || {};
    commit(CONFIG_LOAD_APP, runtimeConfig);
  },
};

const getters = {
  appConfig: state => state.appConfig,
};

export default {
  state,
  mutations,
  actions,
  getters
};
